import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Pro-Spiel Reward-State — persistiert in localStorage */
export interface GameProgress {
  /** Anzahl gespielter Runden */
  roundsPlayed: number;
  /** Anzahl gewonnener Runden (Pokal erreicht) */
  roundsWon: number;
  /** Höchster Score */
  highScore: number;
  /** Gesammelte Sterne (1 pro korrekter Antwort) */
  totalStars: number;
}

interface RewardState {
  /** Progress pro Spiel-ID */
  progress: Record<string, GameProgress>;
  /** Reward nach einer Runde updaten */
  recordRound: (gameId: string, won: boolean, score: number, stars: number) => void;
  /** Progress für ein Spiel abrufen */
  getProgress: (gameId: string) => GameProgress;
  /** Alle Stats zurücksetzen */
  resetAll: () => void;
}

function emptyProgress(): GameProgress {
  return { roundsPlayed: 0, roundsWon: 0, highScore: 0, totalStars: 0 };
}

export const useRewardStore = create<RewardState>()(
  persist(
    (set, get) => ({
      progress: {},
      recordRound: (gameId, won, score, stars) =>
        set((state) => {
          const current = state.progress[gameId] ?? emptyProgress();
          return {
            progress: {
              ...state.progress,
              [gameId]: {
                roundsPlayed: current.roundsPlayed + 1,
                roundsWon: current.roundsWon + (won ? 1 : 0),
                highScore: Math.max(current.highScore, score),
                totalStars: current.totalStars + stars,
              },
            },
          };
        }),
      getProgress: (gameId) => get().progress[gameId] ?? emptyProgress(),
      resetAll: () => set({ progress: {} }),
    }),
    { name: 'seva-lernspiele-rewards' },
  ),
);
